import { render, staticRenderFns } from "./FormularioOrden.vue?vue&type=template&id=4fb36cd6"
import script from "./FormularioOrden.vue?vue&type=script&lang=js"
export * from "./FormularioOrden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports